import { render, staticRenderFns } from "./ModuleLayout.vue?vue&type=template&id=41983bb4&scoped=true"
import script from "./ModuleLayout.vue?vue&type=script&lang=js"
export * from "./ModuleLayout.vue?vue&type=script&lang=js"
import style0 from "./ModuleLayout.vue?vue&type=style&index=0&id=41983bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41983bb4",
  null
  
)

export default component.exports